import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from '@env/environment';
import {lastValueFrom, Observable} from 'rxjs';
import {ApplicationFormRedirectRequest, CurrentLandlordModel, QrCodeDestination} from '../model/landlord.model';
import {LandlordPropertiesResponse, LandlordPropertyModel} from '../model/landlordProperty.model';
import {LocationOffering} from '../model/side-nav.model';

export const SUPPORTED_OFFERING_TYPES: string[] = ['DISTRICT',
  'STORAGE',
  'KIOSK',
  'SPACES',
  'GENERAL_LEASING',
  'POP_UPS',
  'DIGITAL_ADVERTISING',
  'MARKETS',
  'EXHIBITIONS',
  'ON_DEMAND'];

@Injectable({
  providedIn: 'root'
})
export class LandlordsService {

  offeringTypes: string[] = SUPPORTED_OFFERING_TYPES;

  constructor(private http: HttpClient) {
  }

  getPropertiesForLandlord(landlordUuid: string): Promise<LandlordPropertyModel[]> {

    return lastValueFrom(this.http.get<LandlordPropertiesResponse>(environment.apiLandlordHost + `/console/landlord/${landlordUuid}/location`))
      .then((result: LandlordPropertiesResponse) => {
        return result.content;
      }, (error: string) => {
        console.log(error);
        return [];
      })
      .then((result: LandlordPropertyModel[]) => {
        result.forEach((property: LandlordPropertyModel) => {
          lastValueFrom(this.getOfferingsForLocation(property.uuid,
            this.offeringTypes))
            .then((offerings: LocationOffering[]) => {
              property.locationOfferings = offerings;
            })
            .catch((error: string) => {
              console.log(error);
            });
        });
        return Promise.resolve(result);
      });
  }

  getLandlordProperty(landlordUuid: string, locationUuid: string): Observable<LandlordPropertyModel> {
    return this.http.get<LandlordPropertyModel>(environment.apiLandlordHost + `/console/landlord/${landlordUuid}/location/${locationUuid}`)
  }

  getLandlord(landlordId: string): Observable<CurrentLandlordModel> {
    return this.http.get<CurrentLandlordModel>(environment.apiLandlordHost + `/api/public/landlord/${landlordId}`);
  }

  getOfferingsForLocation(locationUuid: string, offeringTypes: string[]): Observable<LocationOffering[]> {
    const params = {
      offeringTypes
    }
    return this.http.get<LocationOffering[]>(environment.apiLandlordHost +
      `/console/landlord/location/${locationUuid}/platform/offering`, {params: params}
    );
  }

  getLandlordWithCode(landlordCode: string): Observable<CurrentLandlordModel> {
    let params = {
      code: landlordCode
    }
    return this.http.get<CurrentLandlordModel>(environment.apiLandlordHost + `/api/public/landlord`, {params: params});
  }

  uploadFloorPlan(file: File, locationUuid: string, locationOfferingUuid: string): Observable<LocationOffering> {
    const formData = new FormData();
    formData.append('file', file);
    const uri = `${environment.apiLandlordHost}/console/landlord/location/${locationUuid}/platform/offering/${locationOfferingUuid}/floor-plan/upload`;
    return this.http.post<LocationOffering>(uri, formData);

  }

  public updateQrCodeUrl(url: string | null, offering: LocationOffering): Observable<any> {
    const uri = `${environment.apiLandlordHost}/console/landlord/location/${offering.locationUuid}/platform/offering/${offering.offeringUuid}/qr-code`;
    return this.http.post(uri, url);
  }

  public updateApplicationFormRedirect(request: ApplicationFormRedirectRequest, offering: LocationOffering): Observable<LocationOffering> {
    const uri = `${environment.apiLandlordHost}/console/landlord/location/${offering.locationUuid}/platform/offering/${offering.offeringUuid}/app-form-redirect`;
    return this.http.post<LocationOffering>(uri, request);
  }

  public updateSurveyQrCodeUrl(offering: LocationOffering, updateRequest: QrCodeDestination): Observable<any> {
    const uri = `${environment.apiLandlordHost}/console/landlord/location/${offering.locationUuid}/platform/offering/${offering.offeringUuid}/survey/qr-code`;
    return this.http.post(uri, updateRequest);
  }
}
